import { call, put, select } from 'typed-redux-saga';

import { selectRoomAgentCanToggleVideo } from '../../../config/selectors';
import {
    DTMF_COMMANDS,
    dtmfCloseCommandListSaga,
    dtmfOpenCommandListSaga,
    dtmfToggleGridViewSaga,
    dtmfToggleHandSaga,
    dtmfToggleMuteAudioSaga,
} from '../dtmf-commands';
import { BaseState } from './base-state';
import { StateId } from './types';

const COMMAND_LIST_STATE_TRANSITIONS: Record<string, StateId> = {
    [DTMF_COMMANDS.common.close]: 'idle',
    [DTMF_COMMANDS.muteAudio.toggle]: 'idle',
    [DTMF_COMMANDS.muteVideo.toggle]: 'idle',
    [DTMF_COMMANDS.gridView.toggle]: 'idle',
    [DTMF_COMMANDS.participantList.open]: 'participant-list',
    [DTMF_COMMANDS.hand.toggle]: 'idle',
};

export class CommandListState extends BaseState {
    public id: StateId = 'command-list';

    public *process(command: string) {
        if (command === DTMF_COMMANDS.muteAudio.toggle) {
            yield* call(dtmfToggleMuteAudioSaga);
        }

        if (command === DTMF_COMMANDS.muteVideo.toggle && !(yield* select(selectRoomAgentCanToggleVideo))) {
            return;
        }

        if (command === DTMF_COMMANDS.hand.toggle) {
            yield* call(dtmfToggleHandSaga);
        }

        if (command === DTMF_COMMANDS.gridView.toggle) {
            yield* call(dtmfToggleGridViewSaga);
        }

        if (COMMAND_LIST_STATE_TRANSITIONS[command]) {
            yield* put(this.context.requestTransitionChannel, COMMAND_LIST_STATE_TRANSITIONS[command]);
        }
    }

    public *onEnter() {
        yield* call(dtmfOpenCommandListSaga);
    }

    public *onExit() {
        yield* call(dtmfCloseCommandListSaga);
    }
}
